import { array, boolean, number, object, string } from 'yup'
import { MembersResult, SearchMemberResult } from './member.types'

export const MemberVehiclesSchema = object({
  vehicles: array().of(
    object({
      make: string(),
      model: string(),
      year: number(),
      vin: string(),
      id: string(),
    })
  ),
})

export const MemberSchema = object({
  basicAddress: string().nullable(),
  city: string().nullable(),
  countryCode: string().nullable(),
  eligible: boolean().nullable(),
  ersAbuser: boolean().nullable(),
  expirationDate: string().nullable(),
  firstName: string().nullable(),
  lastName: string().nullable(),
  memberVehicles: array().of(MemberVehiclesSchema).nullable(),
  membershipNumber: string().nullable(),
  noteText: string().nullable(),
  plusIndicator: string().required(),
  membershipLevel: string().required(),
  postalCode: string().nullable(),
  preferredAARs: string().nullable(),
  stateProvince: string().nullable(),
  statusCode: string().nullable(),
  supplementalAddress: string().nullable(),
  supplementalTelephoneNumber: string().nullable(),
  telephoneNumber: string().nullable(),
  hasRemainingEntitlements: boolean().nullable(),
  membershipRenewalRequired: boolean().nullable(),
  codIndicator: boolean().nullable(),
  paymentLink: string().nullable(),
  supportManagerQuickRenewFlag: boolean().nullable(),
})

const MembersResultSchema = object<MembersResult>().shape({
  resultId: string(),
  streetNumber: string(),
})

export const SearchMemberResultSchema = object<SearchMemberResult>().shape({
  searchId: string(),
  members: array().of(MembersResultSchema),
})
